import { get } from './localStorage';

export const isAuthenicated = () => !!get('credentials');

export default isAuthenicated;



// WEBPACK FOOTER //
// ./src/utils/session.js